import Cookies from "js-cookie";
import cookieEvent from "./events/coookieEvent";

const init = () => {
  document.addEventListener("DOMContentLoaded", () => {});

  /*FIRE cookieEvent EVENT WHEN THE PAGE IS LOADED TO
 CHECK IF USER CHANGED THE COOKIE VALUE */

  document.addEventListener("DOMContentLoaded", function(e) {
    const KL_FORMS_MODAL_COOKIE = Cookies.get("KL_FORMS_MODAL");
    if (
      typeof KL_FORMS_MODAL_COOKIE !== "undefined" &&
      KL_FORMS_MODAL_COOKIE !== null
    ) {
      console.log("KL_FORMS_MODAL", Cookies.get("KL_FORMS_MODAL"));
      const KL_FORMS_MODAL = JSON.parse(KL_FORMS_MODAL_COOKIE);
      if (typeof KL_FORMS_MODAL.disabledForms !== "undefined") {
        console.log(
          "KL_FORMS_MODAL.disabledForms",
          KL_FORMS_MODAL.disabledForms
        );
        if (
          typeof KL_FORMS_MODAL.disabledForms.K65JPD !== "undefined" &&
          typeof KL_FORMS_MODAL.disabledForms.K65JPD.successActionTypes !==
            "undefined" &&
          KL_FORMS_MODAL.disabledForms.K65JPD.successActionTypes !== null
        ) {
          console.log("submit to action types");
          if (
            KL_FORMS_MODAL.disabledForms.K65JPD.successActionTypes[0] ===
            "SUBMIT_TO_LIST_AND_TRANSITION_VIEW"
          ) {
            console.log("should unhide discount banner");
            var discountBanner = document.querySelector(
              "[data-discount-banner]"
            );
            discountBanner.addEventListener("click", function() {
              window.location.href = "/discount/welcome20";
            });
            discountBanner.classList.remove("hidden");
          }
        }
      }
    } else {
      e.target.dispatchEvent(cookieEvent);
    }
  });

  document.addEventListener("cookieChanged", function(e) {
    e.detail.listenCheckChange();
    if (e.detail.changed === true) {
      console.log(e.detail);
      checkKlavioCookies();
    }
  });
};

const checkKlavioCookies = () => {
  const KL_FORMS_MODAL_COOKIE = Cookies.get("KL_FORMS_MODAL");
  if (
    typeof KL_FORMS_MODAL_COOKIE !== "undefined" &&
    KL_FORMS_MODAL_COOKIE !== null
  ) {
    const KL_FORMS_MODAL = JSON.parse(Cookies.get("KL_FORMS_MODAL"));
    console.log(
      "KL_FORMS_MODAL CHECK",
      KL_FORMS_MODAL,
      KL_FORMS_MODAL.disabledForms
    );
    if (KL_FORMS_MODAL.disabledForms.hasOwnProperty("K65JPD")) {
      setTimeout(() => {
        var xpath = "//button[text()='START SHOPPING']";
        var startShoppingBtn = document.evaluate(
          xpath,
          document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;
        console.log("startShoppingbtn", startShoppingBtn);
        if (
          typeof startShoppingBtn !== "undefined" &&
          startShoppingBtn !== null
        ) {
          console.log(
            'add event listener to the "start shopping" button please'
          );
          startShoppingBtn.addEventListener("click", function() {
            var discountBanner = document.querySelector(
              "[data-discount-banner]"
            );
            discountBanner.classList.remove("hidden");
            window.location = "https://enewtondesign.com/discount/welcome20";
          });
        }
      }, 500);
    } else {
      console.log(
        "KL_FORMS_MODAL.disabledForms does not inlcude the form we need"
      );
    }
  }
};

export default init;
